import api from '@/shared/api/api';
import { AssetService } from '@/shared/api/protocol-ts/api/core/svc_asset_connectweb';
import {
  DeleteAssetReq,
  DeleteAssetResp,
  SetMedicalImageViewOptionsReq,
  SetMedicalImageViewOptionsResp,
  SetTopLayerAnnotationsReq,
  SetTopLayerAnnotationsResp,
} from '@/shared/api/protocol-ts/api/core/svc_asset_pb';
import { SliceName } from '@/shared/config';
import { createThunkGenerator } from '@/shared/lib';

type AssetsRequests = keyof typeof AssetService.methods;

const generateAssetThunk = createThunkGenerator<AssetsRequests>(
  SliceName.assets,
);

export const setTopLayerAnnotations = generateAssetThunk<
  SetTopLayerAnnotationsReq,
  SetTopLayerAnnotationsResp
>('setTopLayerAnnotations', api.assets.setTopLayerAnnotations);

export const setMedicalImageViewOptions = generateAssetThunk<
  SetMedicalImageViewOptionsReq,
  SetMedicalImageViewOptionsResp
>('setMedicalImageViewOptions', api.assets.setMedicalImageViewOptions);

export const deleteAsset = generateAssetThunk<DeleteAssetReq, DeleteAssetResp>(
  'deleteAsset',
  api.assets.deleteAsset,
);
